import { Helper } from '../../Common/Helpers/helper';
import { DropInQueueService } from './dropin-queue.service';
import { GeneralService } from '../general.service';
import { EventEmitter } from '@angular/core';
import { SpaLogger } from 'Public_old/src/app/Common/Classes/Global/spalogger.class';
import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';

export class DropInQueueQueue {
	handshakeInterval: any;
	data: any = null;
	onDataEvent: EventEmitter<any> = new EventEmitter<any>();
	waitTimeString: string = '-';

	private intervalHandler = null;

	constructor(
		private spaLogger: SpaLogger,
		private _generalService: GeneralService,
		private queueContext: DropInQueueService,
		private translateService: TranslateService,
		private helper: Helper,
	) {
		this.queueContext.webSocket.init();

		// Touch pining
		this.intervalHandler = window.setInterval(() => {
			this._generalService.touchSession().subscribe();
		}, 60 * 1000);
	}

	destroy() {
		if (this.intervalHandler) {
			clearInterval(this.intervalHandler);
			this.intervalHandler = null;
		}
	}

	setData(data: any): void {
		this.data = data;
		if (this.data.placeInQueue === 0) {
			this.data.placeInQueue = null;
		}
		this.onDataEvent.emit(data);
	}

	handshake(key, answerTime) {
		var ti = answerTime;
		const that = this;

		// If doctors pressed twice, remove first
		if (document.querySelector('.handshakeContainer')) document.querySelector('.handshakeContainer').remove();

		clearInterval(this.handshakeInterval);
		var hscw = document.createElement('div');
		hscw.className = 'handshakeContainerWrap';
		hscw.innerHTML = `<div class="handshakeContainer">
                                <div class="message">
                                    <h2>${this.translateService.get('LicenceHolder.DropInQueue.Phrase.TheDoctorIsReady')}</h2>
                                    <div class="timer">${this.translateService.get(
																			'LicenceHolder.DropInQueue.Phrase.AnswerWithin',
																		)} <span>${ti}</span> ${this.translateService.get('Common.Word.Seconds').toLowerCase()}.</div>
                                    <div class="btn">${this.translateService.get('LicenceHolder.DropInQueue.Button.GoToCall')}</div>
                                </div>
                            </div>`;

		document.querySelector('.template_queueNotifications').appendChild(hscw);

		hscw.querySelector('.btn').addEventListener('click', () => {
			clearInterval(this.handshakeInterval);
			hscw.parentElement.removeChild(hscw);

			this.queueContext.webSocket.send('handshakeresponse', { handshakeKey: key });
			this.queueContext.onAcceptHandshake();
		});

		this.handshakeInterval = window.setInterval(() => {
			ti--;
			(hscw.querySelector('.timer span') as HTMLElement).innerText = ti;

			if (ti === 0) {
				this.queueContext.webSocket.send('handshaketimeout', { handshakeKey: key });

				clearInterval(that.handshakeInterval);
				hscw.remove();
			}
		}, 1000);
	}

	/**
	 * Handshake failed
	 */
	handshakeFailed() {
		clearInterval(this.handshakeInterval);
		if (document.querySelector('.handshakeContainerWrap')) document.querySelector('.handshakeContainerWrap').remove();

		var hscw = document.createElement('div');
		hscw.className = 'timeoutContainerWrap';
		hscw.innerHTML = `<div class="timeoutContainer">
                                <div class="message">
                                    <h2>${this.translateService.get('LicenceHolder.DropInQueue.Phrase.YouMissedYourCall')}</h2>
                                    ${this.translateService.get('LicenceHolder.DropInQueue.Phrase.YouHaveToAnswerWithin', {
																			seconds: this.queueContext.room.roomInfo.HandshakeTimeout,
																		})}
                                    <div class="btn">${this.translateService.get(
																			'LicenceHolder.DropInQueue.Button.NewQueuePlace',
																		)}</div>
                                </div>
                            </div>`;

		document.querySelector('.template_queueNotifications').appendChild(hscw);

		hscw.querySelector('.btn').addEventListener('click', () => {
			hscw.parentElement.removeChild(hscw);
			this.queueContext.webSocket.send('endtimeout', null);
		});
	}
}
